<mat-button-toggle class="dark-mode-button" [checked]="darkMode$ | async" (change)="onToggle()" [matTooltip]="'This is an experimental feature.\n Some things may display incorrectly.'" [matTooltipDisabled]="darkModeActive">
    <span class="label" *ngIf="!darkModeActive">Dark Mode  </span>
    <span class="label" *ngIf="darkModeActive">Light Mode  </span>
    <mat-icon *ngIf="!darkModeActive">dark_mode</mat-icon>
    <mat-icon *ngIf="darkModeActive">light_mode</mat-icon>
</mat-button-toggle>
